// app/ClientShell.tsx
"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

import { Providers } from "@/components/providers"
import { AppLayoutSlotted } from "@workspace/ui/components/own/app-layout-slotted"
import { SidebarMenu } from "@workspace/ui/components/own/sidebar-menu"
import { Topbar } from "@workspace/ui/components/own/topbar"
import { SidebarToggleButton } from "@workspace/ui/components/own/sidebar-toggle"
import { PlainMenu } from "@workspace/ui/components/own/plainmenu"
import { ThemeToggle } from "@workspace/ui/components/own/theme-toggle"

import {
    Home,
    Star,
    CreditCard,
    Mail,
    LogIn,
    FileText,
    Scale,
} from "lucide-react"

export const menuItems = [
    { label: "Home", href: "/", icon: Home },
    { label: "Leistungen", href: "/leistungen", icon: Star },
    { label: "Preise", href: "/preise", icon: CreditCard },
    { label: "Kontakt", href: "/kontakt", icon: Mail },
    { label: "Anmeldung", href: "/login", icon: LogIn },
    { label: "AGB", href: "/agb", icon: Scale },
    { label: "Impressum", href: "/impressum", icon: FileText },
]

export const menuItemsTop = [
    { label: "Home", href: "/", icon: Home },
    { label: "Leistungen", href: "/leistungen", icon: Star },
    { label: "Preise", href: "/#preise", icon: CreditCard },
    { label: "Kontakt", href: "/kontakt", icon: Mail },
    { label: "Anmeldung", href: "/login", icon: LogIn },
]

export default function ClientShell({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()

    return (
        <Providers>
            <AppLayoutSlotted LinkComponent={Link} sidebarDefaultOpen={false}>
                <AppLayoutSlotted.SidebarHeader>Immosphere</AppLayoutSlotted.SidebarHeader>

                <AppLayoutSlotted.SidebarNav>
                    <SidebarMenu items={menuItems} pathname={pathname} LinkComponent={Link} />
                </AppLayoutSlotted.SidebarNav>

                <AppLayoutSlotted.SidebarFooter />

                <AppLayoutSlotted.Topbar>
                    <Topbar variant="elevated" size="md" color="secondary" sticky>
                        <Topbar.Left>
                            <SidebarToggleButton />
                            <span>Immosphere</span>
                        </Topbar.Left>

                        <Topbar.Center>
                            <PlainMenu
                                items={menuItemsTop}
                                LinkComponent={Link}
                                activeStyle="soft-glow"
                                size="md"
                            />
                        </Topbar.Center>

                        <Topbar.Right>
                            <ThemeToggle />
                        </Topbar.Right>
                    </Topbar>
                </AppLayoutSlotted.Topbar>

                <AppLayoutSlotted.Content>{children}</AppLayoutSlotted.Content>

                <AppLayoutSlotted.Footer>
                    <div className="border-t px-6 py-3 text-sm flex items-center justify-between">
                        <span>© {new Date().getFullYear()} Immosphere</span>
                        <div className="flex gap-4">
                            <a href="/impressum" className="hover:underline">
                                Impressum
                            </a>
                            <a href="/agb" className="hover:underline">
                                AGB
                            </a>
                        </div>
                    </div>
                </AppLayoutSlotted.Footer>
            </AppLayoutSlotted>
        </Providers>
    )
}
